export const MIN_COLUMN_SIZE = 120;
export const MAX_COLUMN_SIZE = 500;
export const RATIO_SIZE = 570; // Meant to be sidebar size, but as for me, it's a magic number, however, it works just fine...
export const PAGE_SIZES = [10, 25, 50];
export const DEFAULT_PAGE_SIZE = 10;
